export const normalizePath = (value = '') => {
  const path = String(value || '').trim();
  if (!path) return '';
  const withLeadingSlash = path.startsWith('/') ? path : `/${path}`;
  return withLeadingSlash.replace(/\/+$/, '');
};

const stripLeadingSlash = (path = '') => path.replace(/^\//, '');

const isProjectOverviewAlias = (pathname = '', link = '') => (
  normalizePath(link) === '/delivery/project-overview'
  && normalizePath(pathname).startsWith('/delivery/project-details')
);

const getNestedSubmenuItems = (submenuItem = {}) => (
  submenuItem?.submenuOptions?.length
    ? submenuItem.submenuOptions
    : (submenuItem?.submenuItems || [])
);

const doesPathMatch = ({ pathname, link, exactOnly = false }) => {
  const normalizedPathname = normalizePath(pathname);
  const normalizedLink = normalizePath(link);

  if (!normalizedPathname || !normalizedLink) return false;
  if (normalizedPathname === normalizedLink) return true;
  if (isProjectOverviewAlias(normalizedPathname, normalizedLink)) return true;
  if (exactOnly) return false;

  const pathnameWithoutLeadingSlash = stripLeadingSlash(normalizedPathname);
  const linkWithoutLeadingSlash = stripLeadingSlash(normalizedLink);

  return (
    pathnameWithoutLeadingSlash.startsWith(`${linkWithoutLeadingSlash}/`)
    || pathnameWithoutLeadingSlash.endsWith(`/${linkWithoutLeadingSlash}`)
    || pathnameWithoutLeadingSlash.includes(`/${linkWithoutLeadingSlash}/`)
  );
};

const findActiveIdsForPath = ({ menuItems = [], pathname = '', exactOnly = false }) => {
  for (const item of menuItems) {
    if (doesPathMatch({ pathname, link: item?.link, exactOnly })) {
      return {
        activeMenuItem: item.id,
        activeSubmenuItem: null,
        activeSubmenuOption: null,
      };
    }

    for (const submenuItem of item?.submenuItems || []) {
      if (doesPathMatch({ pathname, link: submenuItem?.link, exactOnly })) {
        return {
          activeMenuItem: item.id,
          activeSubmenuItem: submenuItem.id,
          activeSubmenuOption: null,
        };
      }

      for (const nestedSubmenuItem of getNestedSubmenuItems(submenuItem)) {
        if (doesPathMatch({ pathname, link: nestedSubmenuItem?.link, exactOnly })) {
          return {
            activeMenuItem: item.id,
            activeSubmenuItem: submenuItem.id,
            activeSubmenuOption: nestedSubmenuItem.id,
          };
        }
      }
    }
  }

  return null;
};

export const getActiveIdsFromPath = (menuItems = [], pathname = '') => {
  const exactMatch = findActiveIdsForPath({ menuItems, pathname, exactOnly: true });
  if (exactMatch) return exactMatch;

  return findActiveIdsForPath({ menuItems, pathname, exactOnly: false });
};
